import { render, staticRenderFns } from "./ReportsDeliveryAlertHistoryView.vue?vue&type=template&id=7d4b90e6"
import script from "./ReportsDeliveryAlertHistoryView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryAlertHistoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports